import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        mapping: {
          leaseImportTemplateFile: string
        }
      }
    }
  }
}

export default function template(): Promise<string> {
  return client.gql.query({ query }).then(
    ({
      data: {
        viewer: {
          company: {
            mapping: { leaseImportTemplateFile },
          },
        },
      },
    }: Payload) => leaseImportTemplateFile
  )
}

const query = gql`
  query LeaseImportTemplate {
    viewer {
      company {
        mapping {
          leaseImportTemplateFile
        }
      }
    }
  }
`
